import type { Component, Entity2D } from '../../odie';
import type { GameScene } from '../GameScene';

import { ParcelsBlockProps } from '../defs/block';
import { ParcelsBlockView } from '../views/blocks/ParcelsBlockView';

export type ParcelsBlockComponentOptions = {
  props: ParcelsBlockProps;
  option?: number;
};

/*
  parcels block component
*/
export class ParcelsBlockComponent implements Component {
  public static readonly NAME = 'blockParcels';
  public entity!: Entity2D;
  public view!: ParcelsBlockView;

  public init(options: ParcelsBlockComponentOptions): void {
    this.view = new ParcelsBlockView(options.props);
    this.entity.c.block.signals.onGameStart.connect(() =>
      this.updateEnabledState(),
    );
  }

  public updateEnabledState() {
    const scene = this.entity.scene as GameScene;
    if (!scene) return;
    const remaining = scene.sessionEntity.c.state.parcelThrowsRemaining;
    this.view.enabled = remaining > 0;
  }
}
